/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import { PoaPdfMultiFieldRowClassName } from '@/constants/constants'
import { Utility } from "@/utils";

const FormRow = (props:any) => {
    const {children, node} = props
    const multiField =
        Array.isArray(node?.nodes) && node.nodes.length > 1
            ? PoaPdfMultiFieldRowClassName
            : ''
        return (
            <div className={`Question-raw-wrapper flex gap-2 ${Utility.getClassForWidth(node)} ${multiField}`.trim()}>
    {children}           
            </div>
        )
    
}

export default FormRow;